import { processHeading } from '@workspace/lib/heading-utils';
import { cn } from '@workspace/lib';
import type { RefObject } from 'react';
import { Typography } from '@workspace/ui/common';
import { CustomPortableText } from '@workspace/ui/PortableText';
import { CarouselSlide } from '../content-carousel.types';

interface ContentCarouselSlidesTextProps {
  slides: CarouselSlide[];
  emblaRef: RefObject<HTMLDivElement> | ((el: HTMLDivElement | null) => void);
  isCurrentVideo: boolean;
}

export function ContentCarouselSlidesText({ slides, emblaRef, isCurrentVideo }: ContentCarouselSlidesTextProps) {
  return (
    <div className={cn('relative w-full max-h-fit!', isCurrentVideo ? 'md:mt-xl mt-0' : 'md:mt-3xl mt-0')}>
      <div className={cn('embla overflow-hidden pointer-events-none')} ref={emblaRef as any}>
        <div className="embla__container flex will-change-transform max-h-fit!">
          {slides?.map((slide, i) => {
            const { text: resolvedSubHeadingText } = processHeading(slide.subheading);
            return (
              <div key={slide._key ?? i} className="embla__slide flex-[0_0_100%] min-w-0 max-h-fit!">
                <div>
                  <div className="mb-4">
                    <span className="text-2xl font-bold text-primary">
                      {i + 1}
                      <span className="text-xs text-primary align-super ml-1">of {slides?.length}</span>
                    </span>
                  </div>

                  {resolvedSubHeadingText && (
                    <Typography
                      variant="h2"
                      styleVariant="h5"
                      className="tracking-tight text-black font-heading md:mb-2 mb-1 text-left w-full md:max-w-105 wrap-break-word line-clamp-2"
                    >
                      {resolvedSubHeadingText}
                    </Typography>
                  )}

                  {slide.description && slide.description.length > 0 && (
                    <div className="rich-text-container max-w-350 max-h-fit!">
                      <CustomPortableText
                        value={slide.description}
                        // maxLines={3}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
